module.exports = __webpack_public_path__ + "img/06座椅控制器软件著作权.c6616895.png";